import axiosInstance from "../Axios/axiosInstance";

const getCurrentUserData = async () => {
  return await axiosInstance.get(`/user/get_user`);
};

const getAllUsers = async () => {
  return await axiosInstance.get("/users/");
};

const updatePassword = async (data, id) => {
  return await axiosInstance.post(`/users/updatePassword?id=${id}`, data);
};

const registerUser = async (data) => {
  return await axiosInstance.post("/users/", data);
};

const getUserByToken = async () => {
  return await axiosInstance.get("/users/get_user");
};

const authenticate = async (data) => {
  return await axiosInstance.post("/users/authenticate", data);
};

const pinAuth = async (data) => {
  return await axiosInstance.post("/users/pin", { password: data });
};

const deleteUser = async (id) => {
  return await axiosInstance.delete("/users/" + id);
};

const updateUser = async (id, data) => {
  return await axiosInstance.put("/users/admin/" + id, data);
};

export default {
  registerUser,
  authenticate,
  getCurrentUserData,
  updatePassword,
  getAllUsers,
  pinAuth,
  updateUser,
  deleteUser,
  getUserByToken,
};
